export default function() {
  const sobc_language_buttons = document.querySelectorAll('.sobc-button');
  const scoc_language_buttons = document.querySelectorAll('.scoc-button');
  const proceed_sobc_button = document.getElementById('proceed_sobc_button');
  const proceed_scoc_button = document.getElementById('proceed_scoc_button');

  selectLanguage(sobc_language_buttons, proceed_sobc_button);
  selectLanguage(scoc_language_buttons, proceed_scoc_button);
}

function selectLanguage(language_buttons, proceed_button) {
  language_buttons.forEach((element) => {
    element.addEventListener('click', () => {
      //Set active class to highlight button (English is highlighted by default)
      language_buttons.forEach((other_lang_buttons) => {
        other_lang_buttons.classList.remove('active');
      });
      element.classList.toggle('active');
      //Set proceed button url
      proceed_button.href = element.dataset.proceedUrl;
    })
  });
}